import { io } from 'socket.io-client';
import { API_BASE_URL as apiUrl } from './config';

// Remove trailing /api to get base URL
const baseUrl = apiUrl.endsWith('/api')
  ? apiUrl.slice(0, -4)
  : apiUrl;

console.log('[Socket] API URL:', apiUrl);
console.log('[Socket] Connecting to:', baseUrl);

const socket = io(baseUrl, {
  transports: ['websocket', 'polling'],
  reconnectionDelay: 2000,
  reconnectionDelayMax: 10000,
  reconnectionAttempts: 10,
  timeout: 20000
});

socket.on('connect', () => {
  console.log('[Socket] Connected:',
    socket.id, 'transport:',
    socket.io.engine.transport.name);
});

socket.on('connect_error', (err) => {
  console.error('[Socket] Connect error:',
    err.message);
});

socket.on('disconnect', (reason) => {
  console.log('[Socket] Disconnected:', reason);
});

export default socket;
